// schema/marks/link.ts
import { DesignSystem } from "@adornis/chemistry/elements/theming/design.js";
var getAttrs = (dom) => {
  return {
    href: dom.getAttribute("href"),
    target: dom.getAttribute("target") || "_blank"
  };
};
var LINK_SCHEMA = () => ({
  attrs: {
    href: { default: null },
    target: { default: "_blank" }
    // Standardmäßig neues Tab
  },
  inclusive: false,
  // Der Link hört auf, wenn Text ausgewählt wird und ein neuer Link gesetzt wird
  parseDOM: [
    {
      tag: "a[href]",
      getAttrs
    },
    {
      tag: "x-link",
      getAttrs
    },
    {
      tag: `${DesignSystem.prefix}-link`,
      getAttrs
    }
  ],
  toDOM(mark) {
    return [`${DesignSystem.prefix}-link`, { href: mark.attrs.href, target: mark.attrs.target }, 0];
  }
});
var LINK_KEY = "link";
var LINK = {
  [LINK_KEY]: LINK_SCHEMA
};
export {
  LINK,
  LINK_KEY,
  LINK_SCHEMA
};
